<template>
  <v-main ref="content" class="pt-0" v-resize="onResize">
    <v-container fluid>
      <!--v-row>
        <page-title />
      </v-row-->
      <progress-linear :active="loading"></progress-linear>
      <v-row>
        <v-col cols="12">
          <v-card class="d-flex pa-1 bg" outlined>
            <div class="mr-auto d-flex">
              <!-- 펼치기 -->
              <v-tooltip content-class="tooltip" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="filterAreaShown = !filterAreaShown" v-bind="attrs" v-on="on" class="mr-1" color="primary" x-small>
                    <v-icon v-show="!filterAreaShown" small>mdi-arrow-expand-all</v-icon>
                    <v-icon v-show="filterAreaShown" small>mdi-arrow-collapse-all</v-icon>
                  </v-btn>
                </template>
                <span v-show="!filterAreaShown" small>{{ $t('rtrck.tooltip.filter.show') }}</span>
                <span v-show="filterAreaShown" small>{{ $t('rtrck.tooltip.filter.hide') }}</span>
              </v-tooltip>
              <!-- 필터 초기화 -->
              <v-tooltip content-class="tooltip" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" @click="storeInitFilter" class="mr-1" color="primary" x-small>
                    <v-icon small>mdi-find-replace</v-icon>
                  </v-btn>
                </template>
                <span small>{{ $t('rtrck.tooltip.filter.reset') }}</span>
              </v-tooltip>
              <div class="d-flex">
                <!-- 시스템 선택 -->
                <system-linked-combo v-model="selectedSystem" @input="getDateSets" :hideStack="true" auth></system-linked-combo>
                <!-- 데이터 셋 선택 -->
                <v-select v-model="selectedDataSetTime" :items="dataSets" item-text="label" item-value="time" solo dense hide-details class="mr-1 w-auto"></v-select>
                <!-- Client No. 선택 -->
                <v-select v-model="selectedMandt" :items="mandts" item-text="label" item-value="clientNo" solo dense hide-details class="mr-1 w-auto"></v-select>
                <!-- 저장된 필터 선택 -->
                <div class="text-center">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn dark v-bind="attrs" v-on="on" x-small>
                        <v-icon small class="right-10">mdi-database-search</v-icon>
                        {{ $t('rtrck.saved.filter') }}
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item v-for="(filter, seq) in savedFilters" :key="seq" dense link>
                        <v-list-item-title @click="selectSavedFilter(filter)">{{ filter.filterNm }}</v-list-item-title>
                        <v-list-item-action>
                          <v-tooltip content-class="tooltip" right>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on" @click="deleteSavedFilter(filter)" color="grey lighten-1" small>
                                mdi-database-remove
                              </v-icon>
                            </template>
                            <span small>{{ $t('rtrck.tooltip.delete.saved.filter') }}</span>
                          </v-tooltip>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
                <!-- 필터 저장 버튼 -->
                <v-dialog v-model="showFilterSaveDialog" persistent max-width="320px">
                  <template v-slot:activator="{ on: dialog }">
                    <v-tooltip content-class="tooltip" bottom>
                      <template v-slot:activator="{ on: tooltip }">
                        <v-btn :disabled="disableFilterSaveBtn" v-on="{ ...tooltip, ...dialog }" @click="newFilterName = ''" class="mr-1" color="primary" x-small>
                          <v-icon small>mdi-database-plus</v-icon>
                        </v-btn>
                      </template>
                      <span small>{{ $t('rtrck.tooltip.filter.save') }}</span>
                    </v-tooltip>
                  </template>
                  <v-card>
                    <v-card-title>{{ this.$t('rtrck.msg.input.filter.name') }}</v-card-title>
                    <v-card-text>
                      <v-container>
                        <progress-linear :active="saving"></progress-linear>
                        <v-row>
                          <v-col cols="12">
                            <v-text-field v-model="newFilterName" :rules="newFilterNameRules" required outlined class="full-width-textarea"></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn text :disabled="!newFilterName" @click="saveNewFilter">{{ this.$t('common.save') }}</v-btn>
                      <v-btn text @click="showFilterSaveDialog = false">{{ this.$t('common.cancel') }}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
            </div>
            <!-- 조회 버튼 -->
            <div>
              <v-btn @click="complexSearch" color="primary" x-small>
                <v-icon small>mdi-magnify</v-icon>
              </v-btn>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-show="filterAreaShown">
        <v-col cols="12">
          <v-expansion-panels accordion multiple hover tile>
            <v-expansion-panel>
              <v-expansion-panel-header id="rseph0">{{ this.$t('rtrck.title.user') }}</v-expansion-panel-header>
              <v-expansion-panel-content>
                <user-filter :params="params"></user-filter>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header id="rseph1">{{ this.$t('rtrck.title.crol') }}</v-expansion-panel-header>
              <v-expansion-panel-content>
                <crol-filter :params="params"></crol-filter>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header id="rseph2">{{ this.$t('rtrck.title.srol') }}</v-expansion-panel-header>
              <v-expansion-panel-content>
                <srol-filter :params="params"></srol-filter>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header id="rseph3">{{ this.$t('rtrck.title.tcod') }}</v-expansion-panel-header>
              <v-expansion-panel-content>
                <tcod-filter :params="params"></tcod-filter>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <diagram :diagramHeight="diagramHeight" :params="params" :srchData="srchData"></diagram>
        </v-col>
      </v-row>
      <!-- Dialog to notice no data-set -->
      <v-dialog v-model="showNoDataSetDialog" persistent max-width="400px">
        <v-card>
          <v-card-title>
            <v-icon color="primary">mdi-information</v-icon>
          </v-card-title>
          <v-card-text>{{ this.$t('rtrck.msg.no.dataset') }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="showNoDataSetDialog = !showNoDataSetDialog">{{ this.$t('common.confirm') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import { api } from '@/api/common/instances';
import { format, parseISO } from 'date-fns';
import { isEmpty } from 'lodash';
import UserFilter from './SearchUserFilter.vue';
import CrolFilter from './SearchCrolFilter.vue';
import SrolFilter from './SearchSrolFilter.vue';
import TcodFilter from './SearchTcodFilter.vue';
import Diagram from './SearchDiagram.vue';
export default {
  components: {
    UserFilter,
    CrolFilter,
    SrolFilter,
    TcodFilter,
    Diagram,
  },
  data() {
    return {
      filterAreaShown: true,
      loading: false,
      saving: false,
      selectedSystem: { stack: 'ABAP', system: '' },
      dataSets: [],
      selectedDataSetTime: {},
      mandts: [],
      selectedMandt: '',
      savedFilters: [],
      disableFilterSaveBtn: true,
      showFilterSaveDialog: false,
      newFilterName: null,
      newFilterNameRules: [v => (v && v.length <= 32) || `${this.$t('rtrck.msg.length.filter.name')}`],
      showNoDataSetDialog: false,
      srchData: {},
      diagramHeight: 0,
    };
  },
  computed: {
    ...mapGetters('common/system', ['getDescendantsById']),
    ...mapState('extra/auth/role-tracker', ['user', 'crol', 'srol', 'tcod', 'initFilter']),
    params() {
      return {
        svrYmdhms: this.selectedDataSetTime,
        sstmId: this.selectedSystem.system,
        mandt: this.selectedMandt,
      };
    },
  },
  watch: {
    filterAreaShown: {
      handler() {
        if (this.filterAreaShown) {
          this.diagramHeight = window.innerHeight - 778;
        } else {
          this.diagramHeight = window.innerHeight - 166;
        }
      },
    },
    user: {
      deep: true,
      handler: function() {
        if (isEmpty(this.user.user)) this.disableFilterSaveBtn = true;
        else this.disableFilterSaveBtn = false;
        // console.log('에미다... user...', this.user);
      },
    },
    crol: {
      deep: true,
      handler: function() {
        // console.log('에미다... crol...', this.crol);
      },
    },
    srol: {
      deep: true,
      handler: function() {
        // console.log('에미다... srol...', this.srol);
      },
    },
    tcod: {
      deep: true,
      handler: function() {
        // console.log('에미다... tcod...', this.tcod);
      },
    },
  },
  methods: {
    ...mapActions('extra/auth/role-tracker', ['resetStore']),
    storeInitFilter() {
      this.resetStore(this.initFilter);
    },
    async getDateSets() {
      this.loading = true;
      const { data } = await api.get('/rtrck/summary/data-sets', {
        params: {
          sstmId: this.selectedSystem.system,
        },
      });
      if (isEmpty(data)) {
        this.loading = false;
        this.showNoDataSetDialog = true;
        return;
      }
      this.dataSets = data.map(elm => {
        return { label: `${this.$t('rtrck.data.set')}  (  ${format(elm, 'yyyy-MM-dd')}  )`, time: elm };
      });
      this.selectedDataSetTime = this.dataSets[0].time;
      await this.getMandts();
      this.loading = false;
    },
    async getMandts() {
      this.loading = true;
      const { data } = await api.get('/rtrck/summary/mandts', {
        params: {
          svrYmdhms: this.selectedDataSetTime,
          sstmId: this.selectedSystem.system,
        },
      });
      this.mandts = data.map(elm => {
        return { label: `${this.$t('rtrck.field.title.mandt')}  (  ${elm}  )`, clientNo: elm };
      });
      const sapInstance = this.getDescendantsById(this.selectedSystem.system);
      this.selectedMandt = sapInstance[0].jco.clientNumber;
      // 저장된 필터 목록 조회
      this.refreshSavedFilters();
      this.loading = false;
    },
    async saveNewFilter() {
      // console.log('in saveNewFilter()... newFilterName=', this.newFilterName);
      this.saving = true;
      this.disableFilterSaveBtn = true;
      let srchFilter = {
        // eslint-disable-next-line prettier/prettier
        user: { ...this.user, },
        // eslint-disable-next-line prettier/prettier
        crol: { ...this.crol, },
        // eslint-disable-next-line prettier/prettier
        srol: { ...this.srol, },
        // eslint-disable-next-line prettier/prettier
        tcod: { ...this.tcod, },
      };
      const param = new URLSearchParams();
      param.append('sstmId', this.selectedSystem.system);
      param.append('filterNm', this.newFilterName);
      param.append('srchFilter', JSON.stringify(srchFilter));
      const { status } = await api.post('/rtrck/search/save-filter', param);
      if (status == 200) this.refreshSavedFilters();
      this.saving = false;
      this.disableFilterSaveBtn = false;
      this.showFilterSaveDialog = false;
    },
    async refreshSavedFilters() {
      this.loading = true;
      // eslint-disable-next-line prettier/prettier
      const { data } = await api.get('/rtrck/search/filter-list', {
        params: {
          sstmId: this.selectedSystem.system,
        },
      });
      this.savedFilters = data;
      this.loading = false;
    },
    async deleteSavedFilter(filter) {
      // console.log('in deleteSavedFilter()... filter=', filter);
      let confirmRslt = await this.$dialog.confirm(this.$t('rtrck.confirm.filter.delete'));
      if (confirmRslt) {
        this.loading = true;
        const param = new URLSearchParams();
        param.append('seq', filter.seq);
        const { status } = await api.post('/rtrck/search/remove-filter', param);
        if (status == 200) this.refreshSavedFilters();
        this.loading = false;
      }
    },
    selectSavedFilter(filter) {
      // console.log('in selectSavedFilter()... filter=', filter);
      if (isEmpty(filter)) return;
      let f = JSON.parse(filter.srchFilter);
      f.user.regTerm = [parseISO(f.user.regTerm[0]), parseISO(f.user.regTerm[1])];
      f.user.logonTerm = [parseISO(f.user.logonTerm[0]), parseISO(f.user.logonTerm[1])];
      f.user.passTerm = [parseISO(f.user.passTerm[0]), parseISO(f.user.passTerm[1])];
      f.crol.regTerm = [parseISO(f.crol.regTerm[0]), parseISO(f.crol.regTerm[1])];
      f.crol.updTerm = [parseISO(f.crol.updTerm[0]), parseISO(f.crol.updTerm[1])];
      f.srol.regTerm = [parseISO(f.srol.regTerm[0]), parseISO(f.srol.regTerm[1])];
      f.srol.updTerm = [parseISO(f.srol.updTerm[0]), parseISO(f.srol.updTerm[1])];
      this.resetStore(f);
    },
    async complexSearch() {
      this.loading = true;
      if (isEmpty(this.user.user) && isEmpty(this.crol.crol) && isEmpty(this.srol.srol) && isEmpty(this.tcod.tcod)) {
        this.$snackbar(this.$t('rtrck.msg.input.filter'));
        this.loading = false;
        return;
      }
      const param = new URLSearchParams();
      param.append('svrYmdhms', this.selectedDataSetTime);
      param.append('sstmId', this.selectedSystem.system);
      param.append('mandt', this.selectedMandt);
      param.append('user', isEmpty(this.user.user) ? '' : this.user.user);
      param.append('userReg', isEmpty(this.user.registrant) ? '' : this.user.registrant);
      param.append('userRegBgn', this.user.regTerm[0].getTime());
      param.append('userRegEnd', this.user.regTerm[1].getTime());
      param.append('logonBgn', this.user.logonTerm[0].getTime());
      param.append('logonEnd', this.user.logonTerm[1].getTime());
      param.append('passBgn', this.user.passTerm[0].getTime());
      param.append('passEnd', this.user.passTerm[1].getTime());
      param.append('lockStatus', this.user.lockStatus);
      param.append('crol', isEmpty(this.crol.crol) ? '' : this.crol.crol);
      param.append('crolReg', isEmpty(this.crol.crolReg) ? '' : this.crol.crolReg);
      param.append('crolRegBgn', this.crol.regTerm[0].getTime());
      param.append('crolRegEnd', this.crol.regTerm[1].getTime());
      param.append('crolUpd', isEmpty(this.crol.crolUpd) ? '' : this.crol.crolUpd);
      param.append('crolUpdBgn', this.crol.updTerm[0].getTime());
      param.append('crolUpdEnd', this.crol.updTerm[1].getTime());
      param.append('srol', isEmpty(this.srol.srol) ? '' : this.srol.srol);
      param.append('srolReg', isEmpty(this.srol.srolReg) ? '' : this.srol.srolReg);
      param.append('srolRegBgn', this.srol.regTerm[0].getTime());
      param.append('srolRegEnd', this.srol.regTerm[1].getTime());
      param.append('srolUpd', isEmpty(this.srol.srolUpd) ? '' : this.srol.srolUpd);
      param.append('srolUpdBgn', this.srol.updTerm[0].getTime());
      param.append('srolUpdEnd', this.srol.updTerm[1].getTime());
      param.append('tcod', isEmpty(this.tcod.tcod) ? '' : this.tcod.tcod);
      // eslint-disable-next-line prettier/prettier
      const { data } = await api.post('/rtrck/search/complex-search', param);
      this.srchData = data;
      //**********************************************************************************************************************************
      // SAP에서 데이터가 제대로 관리되지 않아 데이터 정합성이 어긋나지 않는 경우들이 있다.
      // 이 경우 여기서 체크하여 사용자에게 공지한다.
      // 그리고 해당 관계 요소 목록에서는 제거하여 SVG가 rendering 되는 동안 발생되는 오류를 막는다.
      // 2020.12.24.KWShin.
      //----------------------------------------------------------------------------------------------------------------------------------
      // 1. spcpList 내역에는 잡히는데 실제로는 typ이 'C'여서 sprfList 내역에 잡히지 않는 경우가 있다.
      this.srchData.spcpList.forEach(spcp => {
        let match = this.srchData.sprfList.filter(sprf => {
          return sprf.profn === spcp.rightName;
        });
        if (match.length == 0) {
          console.log('존재하지 않는 Single profile [%s]이(가) Compoite profile [%s]에 연결되어 있습니다.', spcp.rightName, spcp.leftName);
          const idx = this.srchData.spcpList.indexOf(spcp);
          if (idx > -1) this.srchData.spcpList.splice(idx, 1);
        }
      });
      // 2. cp2uList 내역에는 잡히는데 실제로는 userList에 잡히지 않는 경우가 있다(SAP*의 경우).
      this.srchData.cp2uList.forEach(cp2u => {
        let match = this.srchData.userList.filter(user => {
          return user.bname === cp2u.leftName;
        });
        if (match.length == 0) {
          console.log('존재하지 않는 사용자 [%s]이(가) Compoite profile [%s]에 연결되어 있습니다.', cp2u.leftName, cp2u.rightName);
          const idx = this.srchData.cp2uList.indexOf(cp2u);
          if (idx > -1) this.srchData.cp2uList.splice(idx, 1);
        }
      });
      //**********************************************************************************************************************************
      this.loading = false;
      this.filterAreaShown = false;
      // BEGIN:: Added.by.KWShin.2024.07.05.
      // Filter Area가 보여질 때와 실제로 다이어그램이 보여질 때의 화면 높이가 달라지므로
      // 조회가 완료되는 시점에서 화면의 높이를 조정하여주어야 한다.
      this.$nextTick(() => {
        this.onResize();
      });
      // FINISH:: Added.by.KWShin.2024.07.05.
    },
    expandFilterArea() {
      this.clickPanelHeaders();
    },
    clickPanelHeaders() {
      let arr = [0, 1, 2, 3];
      arr.forEach(el => {
        this.clickPanelHeader(`rseph${el}`);
      });
    },
    clickPanelHeader(panelHeaderId) {
      let el = document.getElementById(panelHeaderId);
      let ev = new Event('click');
      el.dispatchEvent(ev);
    },
    onResize() {
      // BEGIN::Modified.by.KWShin.2024.07.05.
      // page-title 부분을 제거해서 높이 조정.
      // if (this.filterAreaShown) {
      //   this.diagramHeight = window.innerHeight - 778;
      // } else {
      //   this.diagramHeight = window.innerHeight - 166;
      // }
      if (this.filterAreaShown) {
        this.diagramHeight = window.innerHeight - 741;
      } else {
        this.diagramHeight = window.innerHeight - 129;
      }
      // FINISH::Modified.by.KWShin.2024.07.05.
    },
  },
  created() {
    this.storeInitFilter();
  },
  mounted() {
    this.expandFilterArea();
  },
};
</script>

<style lang="scss" scoped>
.tooltip {
  font-size: 11px;
  padding: 3px 5px 3px 5px;
  opacity: 1 !important;
}
.right-10 {
  margin-right: 10px;
}
.v-expansion-panel-content ::v-deep .v-expansion-panel-content__wrap {
  padding: 0;
}
.container {
  padding: 4px 10px;
}
.v-btn {
  margin-right: 4px;
}
</style>
